import { DEDUCTIONS_PROVIDERS } from "..";
import { apiInstance } from "../config/apiInstance";

export type DeleteDeductionsProvidersRequest = {
  employerIdNumber: string;
  deductionId: number;
};

export type DeleteDeductionsProvidersResponse = {
  message?: string;
};

export const deleteDeductionsProviders = async (
  employerIdNumber: string,
  deductionId: number,
): Promise<DeleteDeductionsProvidersResponse> => {
  const response = await apiInstance.delete<DeleteDeductionsProvidersResponse>(
    DEDUCTIONS_PROVIDERS,
    {
      params: { employerIdNumber, deductionId },
    },
  );
  return response.data;
};
